const translations = {
  title: 'Lugares',
  title_person: 'Personas',
  title_fleet: 'Flota',
  'menu.triggers': 'Automatizaciones',
  'menu.integrations': 'Integraciones',
  'menu.import': 'Importar',
  'menu.importHistory': 'Historial de importación',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Historial de exportación',
  'menu.levelsSettings': 'Personalizar niveles',
  'menu.fieldsSettings': 'Personalizar campos adicionales',
  'menu.templates': 'Plantillas de Documento',
  'menu.templateHistory': 'Historial de Documento',
  'menu.qrcode': 'Generador de Código QR',
  'menu.buckets': 'Historial de lotes de Código QR',
  'menu.linktree': 'Personalizar menú de Código QR',
  'menu.publicToken': 'Tokens públicos',
  'menu.placeType': 'Editar nombre del tipo de lugar',
  'menu.placeLevelsEdit': 'Registro de niveles',
  moreOptions: 'Más opciones',
  cardViewSoon: 'Vista de tarjetas (próximamente)',
  activated: 'Activado',
  levels: 'Niveles',
  assets: 'Activos',
  noQrcodeFound: 'No se encontró ningún Código QR',
  'fields.NAME': 'Nombre',
  'fields.INSERTED_AT': 'Fecha de creación',
  'fields.UPDATE_AT': 'Fecha de actualización',
  'guide.text':
    '¡En lugares, creará todas las ubicaciones de su cliente donde realizará sus servicios, externos o internos. ¡Los lugares se basan en una estructura de registro de 4 niveles que se puede personalizar para servir mejor a su operación!',
  'guide.howToCreate': '¿Cómo crear un lugar?',
  'guide.howToEdit': '¿Cómo editar un lugar?',
  'guide.howToDelete': '¿Cómo eliminar un lugar?',
  'guide.howToEditLevels': '¿Cómo editar los niveles de los lugares?',
  'guide.howToEditFields': '¿Cómo editar qué campos adicionales debe tener un lugar?',
  'guide.contact': 'Póngase en contacto y aclare sus dudas'
}

export default translations
